/**
 * Checks whether an object is empty
 * @param obj
 */
export const isEmpty = (obj: any): boolean => {
    return !obj || Object.keys(obj).length === 0;
};

/**
 * Checks whether an object is defined and not null
 * @param obj
 */
export const isDefinedAndNotNull = <T>(obj: T): boolean => {
    return obj !== undefined && obj !== null;
};

/**
 * Checks whether an object is a number
 * @param obj
 */
export const isNumber = (obj: any): boolean => {
    return typeof obj === "number" && !isNaN(obj);
};
